const SYSTEM_THEME_QUERY = "(prefers-color-scheme: dark)";

type ThemeSyncWindow = Pick<
	Window,
	| "addEventListener"
	| "getTheme"
	| "getThemeFilename"
	| "matchMedia"
	| "removeEventListener"
	| "themeCSSLink"
>;

export const syncTheme = (target: ThemeSyncWindow = window) => {
	if (target.themeCSSLink) {
		target.themeCSSLink.href = target.getThemeFilename(target.getTheme());
	}
};

export const setupThemeSync = (target: ThemeSyncWindow = window) => {
	const systemTheme = target.matchMedia(SYSTEM_THEME_QUERY);
	const handleStorage = (event: StorageEvent) => {
		if (event.key === "theme") {
			syncTheme(target);
		}
	};
	const handleSystemThemeChange = () => {
		// Re-run getTheme rather than trusting event.matches so an explicit
		// localStorage preference continues to take priority over the OS.
		syncTheme(target);
	};

	target.addEventListener("storage", handleStorage);
	systemTheme.addEventListener("change", handleSystemThemeChange);

	return () => {
		target.removeEventListener("storage", handleStorage);
		systemTheme.removeEventListener("change", handleSystemThemeChange);
	};
};
